<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow':
        control.elementVal.getValue()?.duringChange === 't' }">
    </div>
    <img class="control__img bg-style border-light"
         [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
         ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
         width="72" height="72" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <div class="control__content datepicker" data-testid="date-format">
        <app-date-picker
            [newDate]="newDate"
            [disabled]="!editable"
            [showYear]="format !== 1"
            (dateChange)="setDate($event)">
        </app-date-picker>
    </div>
    @if (editable) {
        <div class="control__group-btn">
            <button class="control__button bg-default control__button-img color-light"
                (click)="setDateNow()">
                <span class="control__datepicker-set-now">
                    {{ subtitle(1859) }}
                </span>
            </button>
        </div>
    }
    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        @if (editable) {
            <button class="control__button control__button--small bg-default"
                data-testid="resetButton"
                (click)="setDateFromParams()">
                <img class="control__button-img"
                     ngSrc="/assets/img/icons/return.svg"
                     width="40" height="40" alt="" />
            </button>
        }
        @if (editable) {
            <button class="control__button"
                 [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                      'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                      'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                 data-testid="sendButton"
                 (click)="sendDate()">
                <img class="control__button-img"
                     ngSrc="/assets/img/icons/ok.svg"
                     width="40" height="40" alt="" />
            </button>
        }
    </div>
    @if (control.elementVal.getValue()?.duringChange === 't') {
        <div class="control__during-change">
             <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
        </div>
    }
</div>
